export const contentData = [
  {
    name: "Other Lead Details",
    cssClass: "customer-details",
    fields: [
      {
        name: "Name",
        value: "firstName",
        cssClass: "flex-item w-100",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Company",
        value: "companyName",
        cssClass: "flex-item w-100",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Job",
        value: "job",
        cssClass: "flex-item w-100",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
  },
  {
    name: "Lead Owner details",
    cssClass: "customer-details",
    showName: true,
  },
  {
    name: "Lead Details",
    cssClass: "lead-details",
    fields: [
      {
        name: "Id",
        value: "id",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Date",
        value: "createdAt",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "erniee.ai says",
        value: "rating",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Name",
        value: "leadName",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Company",
        value: "company",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Business Type",
        value: "businessType",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Revenue",
        value: "revenue",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Address One",
        value: "addressOne",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Email",
        value: "email",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
      {
        name: "Mobile",
        value: "mobile",
        cssClass: "flex-item",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
  },
  {
    name: "what erniee says",
    cssClass: "lead-history",
    showName: true,
  },
  {
    name: "Call Recording",
    cssClass: "audio",
    fields: [
      {
        name: "",
        value: "isAudioFileDeleted",
        cssClass: "flex-item w-100 audio",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
    iconBreadcrumb: "audioWaveIcon",
  },
  {
    name: "Conversation Summary",
    cssClass: "ai-conversation-summary",
    fields: [
      {
        name: "",
        value: "conversationSummary",
        cssClass: "flex-item w-100 audio",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
    iconBreadcrumb: "summaryIcon",
  },
  {
    name: "Internal Notes",
    cssClass: "comments",
    fields: [
      {
        name: "",
        value: "note",
        cssClass: "flex-item w-100 audio",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
  },
  {
    name: "Lead History",
    cssClass: "lead-history",
    showName: true,
    iconBreadcrumb: "leadHistoryIcon",
  },
  {
    name: "Call Transcript",
    cssClass: "audio-file-string-content",
    fields: [
      {
        name: "",
        value: "audioFileStringContent",
        cssClass: "flex-item w-100 audio",
        headerClass: "heading",
        contentClass: "content w-100",
      },
    ],
    showName: true,
    iconBreadcrumb: "chatIcon",
  },
];

export const buttons = [
  {
    name: "Like",
    class1: "submit-btn",
    iconName: "likeIcon",
    className: "icon-button social-media",
  },
  {
    name: "Dislike",
    class1: "submit-btn",
    iconName: "dislikeIcon",
    className: "icon-button social-media",
  },
];

export const iconButtons = [
  // {
  //   name: "Social",
  //   class1: "submit-btn",
  //   alt: "groups",
  //   width: 50,
  //   height: 50,
  //   url: "https://img.icons8.com/bubbles/50/conference-call.png",
  //   className: "icon-button social-media",
  //   iconName: "allLeads",
  // },
  {
    name: "Identity Intelligence",
    class1: "submit-btn",
    alt: "company",
    width: 50,
    height: 50,
    url: "https://img.icons8.com/bubbles/50/building.png",
    className: "icon-button company-profile",
    iconName: "singleAiIcon",
  },
  {
    name: "Location",
    class1: "submit-btn",
    alt: "point-objects",
    width: 50,
    height: 50,
    url: "https://img.icons8.com/bubbles/50/marker.png",
    className: "icon-button find-location",
    iconName: "locationIcon",
  },
  {
    name: "Call",
    class1: "submit-btn",
    alt: "apple-phone",
    width: 50,
    height: 50,
    url: "https://img.icons8.com/bubbles/50/apple-phone.png",
    className: "icon-button phone-call",
    iconName: "leads",
  },
  {
    name: "Chat",
    class1: "submit-btn",
    alt: "apple-phone",
    width: 50,
    height: 50,
    url: "https://img.icons8.com/bubbles/50/apple-phone.png",
    className: "icon-button phone-call",
    iconName: "chatIcon",
  },
];

export const cornerButtonsAdmin = [
  { name: "Back", class1: "btn-secondary" },
  { name: "Delete", class1: "btn-primary" },
];

export const cornerButtonsCustomer = [
  { name: "Back", class1: "btn-secondary" },
];
